export const getAccessorialsAfterExclusion = ({
    selectedAccessorials,
    accessorialExclusionList,
    isLiftgateTrailer = false,
  }) => {
    return selectedAccessorials
  }